import { EventType } from "./enums";

interface EventCosts {
  event_type: EventType;
  ride_cost?: number | null;
  member_cost?: number | null;
  ga_ticket_cost?: number | null;
  day_pass_cost?: number | null;
}

/**
 * Returns the price (in dollars) the user should pay for an event.
 * A day pass is a flat rate regardless of membership, so it is resolved first.
 * Otherwise members get member_cost (falling back to ga_ticket_cost) and
 * non-members always pay ga_ticket_cost.
 * Ride events always use ride_cost regardless of membership.
 */
export function resolveEventCost(
  event: EventCosts,
  isMember: boolean,
  isDayPass = false,
): number | null {
  if (event.event_type === EventType.Rides) return event.ride_cost ?? null;
  if (isDayPass) return event.day_pass_cost ?? null;
  if (isMember) return event.member_cost ?? event.ga_ticket_cost ?? null;
  return event.ga_ticket_cost ?? null;
}
